import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  dialogTitle: {
    lineHeight: '2 !important',
    padding: '8px 10px !important',
  },
  dialogModal: {
    '& .MuiPaper-root': {
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
      maxWidth: '600px'
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  saveIcon: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end'
  },
  progressBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '150px',
    width: '100%'
  },
  headerTitle: {
    fontWeight: 'bold',
    fontSize: '1.3rem'
  }
}));
export default styles;

export const listItemTextPrimary = {
  fontSize: '1rem',
  fontWeight: 600,
};
